import React from 'react';
import { connect } from 'react-redux';

import { IAppState } from 'src/store';
import { CustomDropdown, Icon } from 'src/components/common';
import { DropdownItem } from 'src/components/common/CustomDropdown';
import { Device } from 'src/services';

const ActionDropdown: React.FC<Props> = ({ options }) => {
  return (
    <CustomDropdown
      xPosition={Device.isMobile ? 'left' : 'right'}
      label={<Icon name="ic_more-vertical" className={'cmp-deposition-file__item-icon'} />}
      items={options}
    />
  );
};

type Props = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps & {
    options: DropdownItem[];
  };

const mapStateToProps = (state: IAppState) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ActionDropdown);
